import { faSave } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormikErrors, useFormik } from 'formik';
import React, { useEffect } from 'react';
import VoxelAutocompleteLanguage from '../../../components/muiLegacy/Autocomplete/VoxelAutocompleteLanguage';
import VoxelLink from '../../../components/voxel/Link/VoxelLink';
import VoxelFormPanel from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanel';
import VoxelFormPanelActionSubmit from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelActionSubmit';
import VoxelPanelActions from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelPanelActions';
import { GoogleAdsLanguageGq } from '../../../graphql/projects/models/GoogleAdsLanguageGq';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import { usersApiService } from '../../../graphql/users/usersApiService';
import { useUserDefaults } from '../../../logic/otherUtilities/useUserDefaults';
import VoxelFormPanelContent from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelContent';

export interface FormState {
  language: GoogleAdsLanguageGq;
}

export interface UserLanguageFormProps {
  user: CurrentUserGq;
  setDirty: (dirty: boolean) => void;
  setSave: (saveFunction: () => Promise<unknown>) => void;
  reload: () => Promise<unknown>;
}

const UserLanguageForm: React.FC<UserLanguageFormProps> = ({
  user,
  setDirty,
  setSave,
  reload,
}) => {

  const defaults = useUserDefaults(user);
  const mutation = usersApiService.mutations.useUpdateUserLanguage();
  const formBag = useFormik<FormState>({
    initialValues: {
      language: defaults.volumeLanguage,
    },
    enableReinitialize: true,
    validate: (values) => {
      const errors: FormikErrors<FormState> = {};
      return errors;
    },
    validateOnChange: true,
    onSubmit: (values, actions) =>
      mutation({ languageId: values.language.id ?? null })
        .catch((error) => console.log(error))
        .then(() => reload()),
  });

  useEffect(() => setSave(formBag.submitForm), [formBag.submitForm]);
  useEffect(() => {
    setDirty(formBag.dirty);
    return () => setDirty(false);
  }, [formBag.dirty]);

  return (
    <VoxelFormPanel
      title={<span>Language</span>}
      subtitle={
        <span>
          Default language setting used when fetching keyword or rank data.
          The language settings are based the list of{' '}
          <VoxelLink
            openInNewIcon
            openInNewTab
            href="https://developers.google.com/google-ads/api/data/codes-formats"
          >
            languages
          </VoxelLink>{' '}
          made availabe by Google Ads.
        </span>
      }>
      <VoxelFormPanelContent>
        <VoxelAutocompleteLanguage
          type="user"
          labelPosition="top"
          selectedLanguage={formBag.values?.language}
          setSelectedLanguage={(option) => formBag.setFieldValue('language', option)}
          disabled={formBag.isSubmitting}
        />
      </VoxelFormPanelContent>
      <VoxelPanelActions>
        <VoxelFormPanelActionSubmit
          title={'Save changes'}
          onClick={formBag.submitForm}
          disabled={
            formBag.isSubmitting || !formBag.isValid || !formBag.dirty
          }
          endIcon={<FontAwesomeIcon icon={faSave} />}
        />
      </VoxelPanelActions>
    </VoxelFormPanel>
  );
};

export default UserLanguageForm;
